import { render, staticRenderFns } from "./ExpertRegionCard.vue?vue&type=template&id=8c689e76&lang=pug&"
import script from "./ExpertRegionCard.vue?vue&type=script&lang=js&"
export * from "./ExpertRegionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports